/* eslint-disable import/no-default-export */
import escapeForRegex from './escape-for-regex';

type Matcher = (input: string) => boolean;

export default (query: string): Matcher => {
  const searchExpressions: RegExp[] = query
    .split(/\s+/)
    .map((word) => new RegExp(escapeForRegex(word), 'i'));

  return (input: string) =>
    searchExpressions.every((searchExpression) => searchExpression.test(input));
};



// WEBPACK FOOTER //
// ./app/gamma/src/util/build-fuzzy-matcher.ts